import styled from 'styled-components';
import { Grid } from 'ui-toolkit';

export const SortableItemContainer = styled(Grid)`
  position: relative;
  grid-template-columns: ${(props) => props.theme.spacing.spacing5} 1fr;
`;

export const SortableListRowContainer = styled(Grid)`
  grid-template-columns: 25fr 1fr 1fr;
  line-height: 1.5;
  cursor: pointer;
  user-select: none;
  white-space: pre-line;
`;

export const SortableListRowAlignRight = styled.div`
  text-align: right;
`;

export const PopupContainer = styled.div`
  position: relative;
  cursor: pointer;
  display: inline-block;
`;
